import React from 'react';
import PropTypes from 'prop-types';
import Util from 'utilities/helper.util';
import { Button } from 'carbon-components-react';
import { getJobStatusCodeMsg } from 'appConstants/enquiry';
import { ChevronUp16, ChevronDown16 } from '@carbon/icons-react';

const PopUp: React.FC<Props> = (props) => {
  const { attributes, onButtonClick } = props;
  const handleButtonClick = () => {
    if (attributes?.objectid && typeof onButtonClick === 'function') {
      onButtonClick(attributes);
    }
  };
  const handleMoreFeatureUp = () => {
    const { loadedView } = window;
    if (loadedView && !loadedView.destroyed && loadedView.popup) {
      loadedView.popup.previous();
    }
  };
  const handleMoreFeatureDown = () => {
    const { loadedView } = window;
    if (loadedView && !loadedView.destroyed && loadedView.popup) {
      loadedView.popup.next();
    }
  };
  const featureCount = window.loadedView?.popup?.featureCount || 1;

  return (
    <div className="history-page-map-popup-container">
      {attributes && (
        <>
          <div className="history-page-map-popup-content">
            <div className="id-container">
              <div className="referral-id">{attributes.external_id}</div>
              {featureCount > 1 && (
                <div className="more-feature">
                  <div
                    className="more-feature-up"
                    onClick={handleMoreFeatureUp}
                  >
                    <ChevronUp16 />
                  </div>
                  <div
                    className="more-feature-down"
                    onClick={handleMoreFeatureDown}
                  >
                    <ChevronDown16 />
                  </div>
                </div>
              )}
            </div>
            <div className="job-id">Job {attributes.enquiry_external_id}</div>
          </div>
          <div className="history-page-map-popup-content">
            <div className="status">
              {getJobStatusCodeMsg(attributes.status)}
            </div>
          </div>
          <div className="history-page-map-popup-content">
            <div className="heading">User ref</div>
            <div>{attributes.enquiry_user_reference}</div>
            <div className="heading">Enquirer</div>
            <div>{attributes.enquiry_user_name}</div>
            <div className="heading">Enquiry date</div>
            <div>{Util.toLocalDateTimeFormat(attributes.created_at)}</div>
          </div>
          <div className="history-page-map-popup-content">
            <Button
              className="refferal-detail-btn"
              kind="tertiary"
              size="field"
              onClick={handleButtonClick}
            >
              View details
            </Button>
          </div>
        </>
      )}
      {!attributes && 'No attributes received'}
    </div>
  );
};

const propTypes = {
  attributes: PropTypes.any,
  onButtonClick: PropTypes.func
};

type Props = PropTypes.InferProps<typeof propTypes>;

PopUp.defaultProps = {
  attributes: null
};

export default PopUp;

export const PopUpOutFields = [
  'objectid',
  'external_id',
  'enquiry_external_id',
  'enquiry_id',
  'status',
  'enquiry_user_reference',
  'enquiry_user_name',
  'created_at'
];
